import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-round-checkbox',
  templateUrl: './round-checkbox.component.html',
  styleUrls: ['./round-checkbox.component.scss'],
  animations: [
    trigger('item', [
      transition(':enter', [
        style({opacity: 0, transform: 'translateX(50%)'}),
        animate('500ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
      ]),
      transition(':leave', [
        style({ opacity: 1}),
        animate('1s cubic-bezier(.8,-0.6,0.2,1.5)',
          style({ transform: 'translateX(-50%)', opacity: 0 }))
      ])
    ])
  ]
})
export class RoundCheckboxComponent implements OnInit {

  @Input() id: string;
  @Input() isSelected: boolean;
  @Input() extraClass: string;
  @Output() click: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  selectByClick(): void {
    this.click.emit();
  }

}
